import { Project } from '../types';

export const calculateRevenue = (matrices: {
  revenue: number[][];
}): number => {
  return matrices?.revenue?.reduce(
    (sum, row) => sum + row.reduce((rowSum, cell) => rowSum + cell, 0),
    0
  ) / 2 || 0;
};

export const calculateNetIncome = (project: Project): number => {
  if (!project.matrices) return 0;

  const revenue = calculateRevenue(project.matrices);
  const passengerKm = project.matrices.passengerKm.reduce(
    (sum, row) => sum + row.reduce((rowSum, cell) => rowSum + cell, 0),
    0
  ) / 2 || 0;
  const networkLength = project.matrices.adjacency.reduce(
    (sum, row) => sum + row.reduce((rowSum, cell) => rowSum + cell, 0),
    0
  ) / 2 || 0;

  const operatingCosts = passengerKm * project.config.costs.operatingCostPerKm;
  const constructionCost = networkLength * project.config.costs.constructionCostPerKm;
  const { duration, interestRate } = project.config.bond;
  const r = interestRate / 100;
  const bondPayments = constructionCost * r * Math.pow(1 + r, duration) / (Math.pow(1 + r, duration) - 1);

  return revenue - operatingCosts - bondPayments;
};

export const calculateNetIncomePercentage = (revenue: number, netIncome: number): number => {
  return revenue > 0 ? (netIncome / revenue) * 100 : 0;
};

export function formatPercentage(value: number): string {
  if (value === 0) return '0%';
  return `${value > 0 ? '+' : ''}${value.toFixed(1)}%`;
}

export const getPercentageColor = (value: number): string => {
  if (value === 0) return 'text-gray-600'; // Regular text color used in the editor
  return value > 0 ? 'text-[#34A853]' : 'text-[#EA4335]';
}; 